import React from 'react';
import { eventsStore, refsStore, datasetStore, videoStore, kioskStore, poiStore, gmapStore} from '../managers/globalState';

import LeftContent from './left-content';

// Todo: This component can be drastically simplified - task #3191.

class DetailPanelLeft extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			showEvent: false,
			showPoI: false,
			showGmap: false,
			open: props.detailPanelOpen || false,
			category: '',
			title: '',
			subtitle: '',
			descriptions: []
		};
		this._lang = window.config && window.config.acceptLanguage && window.config.acceptLanguage == 'ar' ? 'ar' : 'en';
	}

	componentDidMount() {
		this.eventsUnsubscribe = eventsStore.subscribeTo('showOnGlobe', this.toggleEvent.bind(this));
		this.dsUnsubscribe = datasetStore.subscribeAll(() => this.forceUpdate());
		this.videosUnsubscribe = videoStore.subscribeTo('videoId', () => this.forceUpdate());
		this.kioskUnsubscribe = kioskStore.subscribeTo('kioskModeOn', () => this.forceUpdate());
	}

	componentWillUnmount() {
		typeof this.eventsUnsubscribe === 'function' && this.eventsUnsubscribe();
		typeof this.dsUnsubscribe === 'function' && this.dsUnsubscribe();
		typeof this.videosUnsubscribe === 'function' && this.videosUnsubscribe();
		typeof this.kioskUnsubscribe === 'function' && this.kioskUnsubscribe();
	}

	toggleEvent() {
		let { showEvent } = this.state;

		if (eventsStore && eventsStore.state) {
			showEvent = eventsStore.state.showOnGlobe;
		}

		this.setState({ showEvent });
	}

	togglePoI() {
		let { showPoI } = this.state;

		if (poiStore && poiStore.state) {
			showPoI = poiStore.state.showOnGlobePoI;
		}

		this.setState({ showPoI });
	}

	toggleGmap() {
		let { showGmap } = this.state;

		if (gmapStore && gmapStore.state) {
			showGmap = gmapStore.state.showOnGlobeGmap;
		}

		this.setState({ showGmap });
	}

	static getDerivedStateFromProps(nextProps, state) {
		const {
			type,
			open,
			altid,
			altView,
			missionName,
			event,
      poi,
	  gmap,
			vitalsign
		} = nextProps;
		const { get } = refsStore.stateSnapshot;

		const { category, title, subtitle, descriptions } = get(
			'content'
		).getDisplayData({
			view: type,
			missionName,
			vitalsign,
			altid,
			altView,
			event,
			poi,
			gmap
		});
		const props = {
			category,
			title,
			subtitle,
			descriptions,
			open
		};

		const newState = Object.entries(props).reduce((obj, [key, value]) => {
			if (key in state && state[key] !== props[key]) {
				obj[key] = value;
			}
			return obj;
		}, {});

		return newState;
	}

	render() {
		const {
			pioneer,
			type,
			isMobile,
			hideTitle,
			hideButton,
			toggle,
			vitalsign,
			toggleOverlay
		} = this.props;
		const { open, category, title, subtitle, descriptions, showEvent, showPoI, showGmap } = this.state;
		const { get } = refsStore.stateSnapshot;
		const { kioskModeOn } = kioskStore.stateSnapshot;

		const { videoId } = videoStore.stateSnapshot;
		const videoManager = get('video');
		const videoType = videoManager.getVideoType(videoId);
		const globalVideo = videoType === 'global' || videoType === 'geoLocated';
		const satellitesView = type === 'vitalsign' && vitalsign === 'satellites';

		const contentManager = get('content');

		const showDateAndTime = !open && (isMobile && ((type === 'vitalsign' && vitalsign === 'satellites') || type === 'spacecraft'));

		const leftContentProps = {
			isMobile,
			title,
			subtitle,
			open,
			type,
			toggle,
			toggleOverlay,
			category,
			hideTitle,
			hideButton,
			showDateAndTime,
			pioneer
		};

		return (
			<div
				className='left-content col-12 col-lg-7 col-xl-6'
				style={showEvent ? { marginBottom: 10 } : {}}
				stylepoi={showPoI ? { marginBottom: 10 } : {}}
				stylegmap={showGmap ? { marginBottom: 10 } : {}}
			>
				<div className={open ? 'pl-0 pl-lg-4' : `${isMobile ? '' : 'pl-3 mb-3'} mb-lg-0 pb-lg-3`}>
					<LeftContent {...leftContentProps} />

					<div className='info scrollable'>
						{descriptions.map((description, index) => (
							<React.Fragment key={index}>
								<h3 className='section-title pt-lg-3'>
									{description.title}
								</h3>
								{globalVideo && isMobile && (
									<div className='tab-subtitle'>{description.subtitle}</div>
								)}
								{description.html
									? (
										<div
											className='text pb-1'
											dangerouslySetInnerHTML={{
												__html: kioskModeOn
													? contentManager.removeExternalLinks(description.html) :
													description.html
											}}
										/>
									)
									: (
										<div
											className='text pb-1'
											dangerouslySetInnerHTML={{
												__html: kioskModeOn
													? contentManager.removeExternalLinks(description.text) :
													description.text
											}}
										/>
									)}
							</React.Fragment>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default DetailPanelLeft;
